import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";
import { Tools } from "./pages/tools";

const toolsPath = "/tools";

const toolsPageNav = buildBreadcrumbNavigationConfig("Tools", toolsPath);

export const toolsRoutes = [
  {
    path: toolsPath,
    Component: Tools,
    navigation: [toolsPageNav],
    exact: true,
    isPrivate: true,
  },
];
